import { render, staticRenderFns } from "./GoHome.vue?vue&type=template&id=314c0859&scoped=true&"
import script from "./GoHome.vue?vue&type=script&lang=js&"
export * from "./GoHome.vue?vue&type=script&lang=js&"
import style0 from "./GoHome.vue?vue&type=style&index=0&id=314c0859&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314c0859",
  null
  
)

export default component.exports